module.exports = __webpack_public_path__ + "img/dklx_collect.dcf1a334.png";